import React, { useState, useCallback, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import InputMask from "react-input-mask";
import {
  Grid,
  Typography,
  FormControl,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import {
  StyledTextField,
  theme,
  StyledSelect,
  StyledInputLabel,
} from "../StyledComponents";
import { examinationsData } from "../Utils/SectionsDataMap";
import Dental from "../Utils/dental/Dental";

const Examinations = ({
  sectionName,
  activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  dentalData,
  setData,
  setDentalData,
  bloodGroup,
  setBloodGroup,
  doctorData,
}) => {
  const handleVitalChange = (index, newValue) => {
    const updatedVitals = [...data];
    updatedVitals[index].value = newValue;
    setData(updatedVitals);
  };
  console.log("exm doctor", doctorData);
  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: "5px",
            padding: "10px",
          }}
        >
          {/* Vitals/Wellness Section */}
          <Grid item xs={12}>
            <p
              style={{
                fontWeight: 500,
                color: "black",
                fontSize: "12px",
                lineHeight: "1.5",
                marginBottom: "15px",
              }}
            >
              Vitals/Wellness
            </p>

            {/* <Grid container spacing={2}>
              {data.map((vital, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  {vital.name === "BP" ? (
                    <InputMask
                      mask="999/999"
                      maskChar=""
                      value={vital.value}
                      onChange={(e) => handleVitalChange(index, e.target.value)}
                    >
                      {(inputProps) => (
                        <StyledTextField
                          fullWidth
                          label={`${vital.name} (Systolic/Diastolic)`}
                          {...inputProps}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {vital.sign}
                              </InputAdornment>
                            ),
                          }}
                          error={
                            vital.value &&
                            !/^\d{1,3}\/\d{1,3}$/.test(vital.value)
                          }
                          helperText={
                            vital.value &&
                            !/^\d{1,3}\/\d{1,3}$/.test(vital.value)
                              ? "Please enter a valid BP value (e.g., 120/80)"
                              : ""
                          }
                        />
                      )}
                    </InputMask>
                  ) : (
                    <StyledTextField
                      fullWidth
                      label={vital.name}
                      value={vital.value}
                      onChange={(e) => handleVitalChange(index, e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {vital.sign}
                          </InputAdornment>
                        ),
                      }}
                      error={
                        vital.value &&
                        (!/^\d+(\.\d+)?$/.test(vital.value) ||
                          parseFloat(vital.value) <= 0)
                      }
                      helperText={
                        vital.value &&
                        (!/^\d+(\.\d+)?$/.test(vital.value) ||
                          parseFloat(vital.value) <= 0)
                          ? "Please enter a positive number"
                          : ""
                      }
                    />
                  )}
                </Grid>
              ))}
            </Grid> */}
            <Grid container spacing={2}>
              {data.map((vital, index) => {
                const value = vital.value;
                const name = vital.name;

                let error = false;
                let helperText = "";

                if (value) {
                  if (name === "BP") {
                    if (!/^\d{1,3}\/\d{1,3}$/.test(value)) {
                      error = true;
                      helperText =
                        "Format must be Systolic/Diastolic (e.g., 120/80)";
                    } else {
                      const [systolic, diastolic] = value
                        .split("/")
                        .map(Number);
                      if (
                        systolic < 0 ||
                        systolic > 300 ||
                        diastolic < 0 ||
                        diastolic > 300
                      ) {
                        error = true;
                        helperText = "Systolic and Diastolic must be 0–300";
                      }
                    }
                  } else {
                    const numericValue = parseFloat(value);

                    switch (name) {
                      case "Temperature":
                        if (numericValue < 90 || numericValue > 110) {
                          error = true;
                          helperText =
                            "Temperature must be between 90°F and 110°F";
                        }
                        break;
                      case "Pulse":
                        if (numericValue < 0 || numericValue > 250) {
                          error = true;
                          helperText = "Pulse must be between 0 and 250";
                        }
                        break;
                      case "Respiratory Rate":
                        if (numericValue < 0 || numericValue > 70) {
                          error = true;
                          helperText =
                            "Respiratory Rate must be between 0 and 70";
                        }
                        break;
                      case "SPO2":
                        if (numericValue < 0 || numericValue > 100) {
                          error = true;
                          helperText = "SpO2 must be between 0 and 100";
                        }
                        break;
                      case "Height":
                        if (numericValue < 20 || numericValue > 220) {
                          error = true;
                          helperText = "Height must be between 20 and 220";
                        }
                        break;
                      case "Weight":
                        if (numericValue < 1 || numericValue > 300) {
                          error = true;
                          helperText = "Weight must be between 1 and 300";
                        }
                        break;
                      default:
                        if (isNaN(numericValue) || numericValue <= 0) {
                          error = true;
                          helperText = "Please enter a positive number";
                        }
                    }
                  }
                }

                return (
                  <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                    {name === "BP" ? (
                      <InputMask
                        mask="999/999"
                        maskChar=""
                        value={value}
                        onChange={(e) =>
                          handleVitalChange(index, e.target.value)
                        }
                      >
                        {(inputProps) => (
                          <StyledTextField
                            fullWidth
                            label={`${name} (Systolic/Diastolic)`}
                            {...inputProps}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {vital.sign}
                                </InputAdornment>
                              ),
                            }}
                            error={error}
                            helperText={helperText}
                          />
                        )}
                      </InputMask>
                    ) : (
                      <StyledTextField
                        fullWidth
                        label={name}
                        value={value}
                        onChange={(e) =>
                          handleVitalChange(index, e.target.value)
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {vital.sign}
                            </InputAdornment>
                          ),
                          inputProps: {
                            min: 0, // Basic lower bound, specific ones already handled
                            type: "number", // Ensures number-only input
                            step: "0.01", // Allows up to 2 decimal places
                            onWheel: (e) => e.target.blur(), // Prevent scroll
                            onKeyDown: (e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault(); // Prevent arrow key increment/decrement
                              }
                            },
                          },
                        }}
                        error={error}
                        helperText={helperText}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </Grid>

          {/* Dental Chart Section */}
          {doctorData?.department == "Dentistry" ? (
            <Grid item xs={12}>
              <p
                style={{
                  fontWeight: 500,
                  color: "black",
                  fontSize: "12px",
                  lineHeight: "1.5",
                  marginBottom: "15px",
                }}
              >
                Dental Chart
              </p>
              <Dental dentalData={dentalData} setDentalData={setDentalData} />
            </Grid>
          ) : (
            []
          )}

          {/* Profile Section */}
          <Grid item xs={12}>
            <p
              style={{
                fontWeight: 500,
                color: "black",
                fontSize: "12px",
                lineHeight: "1.5",
                marginBottom: "15px",
              }}
            >
              Profile
            </p>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={3}>
                <StyledTextField
                  select
                  label="Blood Group"
                  value={bloodGroup}
                  fullWidth
                  onChange={(e) => setBloodGroup(e.target.value)}
                >
                  <MenuItem value="A+">A+</MenuItem>
                  <MenuItem value="A-">A-</MenuItem>
                  <MenuItem value="B+">B+</MenuItem>
                  <MenuItem value="B-">B-</MenuItem>
                  <MenuItem value="AB+">AB+</MenuItem>
                  <MenuItem value="AB-">AB-</MenuItem>
                  <MenuItem value="O+">O+</MenuItem>
                  <MenuItem value="O-">O-</MenuItem>
                </StyledTextField>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        examinationsData(
          data.some((item) => item.value != ""), //whether there is data present in "data"
          data,
          bloodGroup,
          dentalData.length > 0, //whether there is data present in dentalData,
          dentalData
        )
      )}
    </ThemeProvider>
  );
};

export default Examinations;
